<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                weeks: {},
                submitting: false,
                success: false
            }
        },

        methods: {
            submitForm(event) {
                this.submitting = true;
                axios.post(BAStarter.resturl + 'wp/v2/truck-schedule/update', {
                    weeks: this.weeks
                }, {
                    headers: {
                        'X-WP-Nonce': BAStarter.restnonce
                    }
                }).then(response => {
                    this.submitting = false;
                    this.success = true;
                    setTimeout(() => {
                        this.success = false;
                    }, 2000);
                    console.log(response);
                });
            }
        },

        mounted() {
            // setup models for the different weeks
            for(var ref in this.$refs) {
                this.weeks[ref] = this.$refs[ref].getAttribute('data-value');
            }
            this.$forceUpdate();
        }
    }
</script>


// WEBPACK FOOTER //
// TruckScheduleAdmin.vue?99542c4e